<template>
  <div class="et-line-width" @click="onClick" ref="rootRef">
    <div class="et-line-width-show">
      <div>{{ value }}px</div>
      <div :style="{width: '100%', height: `${value}px`, background: '#fff', margin: '0 4px'}"></div>
    </div>
    <div class="et-line-width-icon">
      <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8 316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496z"></path></svg>
    </div>
  </div>
  <teleport to="body">
    <div class="et-line-width-popover" v-if="data.visible" :style="{
      width: `${data.width}px`, transform: `translate(${data.x}px, ${data.y}px)`}">

      <div class="et-line-width-item" :class="{active: value==i}" @click="onItemClick(i)" v-for="i in lineWidths">
        <div>{{ i }}px</div>
        <div :style="{width: '60%', height: `${i}px`, background: '#000', margin: '0 4px'}"></div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
  import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue'

  const props = defineProps({
    modelValue: {
      type: Number,
      default: 1,
    },
    lineWidths: {
      type: Array,
      default: () => [1, 2, 3, 5, 8],
    },
  })

  const emit = defineEmits(['update:modelValue', 'change'])


  const data = reactive({
    visible: false,
    x: 0,
    y: 0,
    width: 200,
  })


  const rootRef = ref(null)


  const value = computed({
    get() {
      return props.modelValue
    },
    set(val) {
      emit('update:modelValue', val)
      emit('change', val)
    }
  })

  function onClick() {
    data.visible = true

    updatePos()
  }


  function onItemClick(val) {
    value.value = val
    data.visible = false
  }

  function updatePos() {
    const rect = rootRef.value.getBoundingClientRect()
    data.x = rect.left
    data.y = rect.top + rect.height + 2
    data.width = rect.width
  }


  function eventHandler(event) {
    if(event.target.closest('.et-line-width-popover') || event.target.closest('.et-line-width')) {
      return
    }
    data.visible = false
  }


  window.addEventListener('click', eventHandler, true)
  onUnmounted(() => {
    window.removeEventListener('click', eventHandler, true)
  })


</script>

<style scoped>

.et-line-width {
  display: flex;
  align-items: center;
  background: #181c40;
  border: 1px solid #000;
  padding: 0 8px;
  height: 30px;
  position: relative;
  padding-right: 0;
}
.et-line-width-show {
  flex: 1;
  display: flex;
  align-items: center;
  /* justify-content: center; */
}
.et-line-width-icon {
  width: 30px;
  height: 30px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.et-line-width-popover {
  position: fixed;
  padding: 4px;
  width: 200px;
  overflow-y: auto;
  background: #fff;
  /* border: 1px solid #178FFC; */
  left: 0;
  top: 0;

  z-index: 888;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  user-select: none;
}

.et-line-width-item  {
  background: #fbfcfc;
  height: 30px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  font-size: 12px;
}
.et-line-width-item:hover {
  background: #e6e6e6;
}
.et-line-width-item.active {
  background: #178FFC;
}

</style>
